import storage from 'good-storage'

const LANGUAGE_KEY = 'notion_language'

const SOURCE_DETAIL = '__source_detail__'

export function loadLanguage() {
	return storage.get(LANGUAGE_KEY,'en')
}

export function setLanguage(lang) {
  	storage.set(LANGUAGE_KEY,lang)
}

export function setSourceDetail(source){
	source = JSON.stringify(source)
	storage.set(SOURCE_DETAIL,source)
}

export function getSourceDetail(){
	let source = storage.get(SOURCE_DETAIL,false)
	if(!source){
		return false
	}
	return JSON.parse(source)
}

export function clearSourceDetail(){
	storage.remove(SOURCE_DETAIL)
}


// WEBPACK FOOTER //
// ./src/common/js/cache.js